export interface RectangularDimensions {
  width: number;
  height: number;
}

export default function getLogoDimensionsForView (logo: RectangularDimensions, view: RectangularDimensions): RectangularDimensions {
  const viewRatio = view.width / view.height;
  const imageRatio = logo.width / logo.height;
  let adjustedWidth, adjustedHeight;
  if (viewRatio === 1) {
    if (imageRatio > 1) {
      adjustedHeight = view.height / imageRatio;
      adjustedWidth = view.width;
    } else if (imageRatio < 1) {
      adjustedHeight = view.height;
      adjustedWidth = view.width * imageRatio;
    } else {
      // Image and View are both squares, return view's dimensions
      adjustedHeight = view.height;
      adjustedWidth = view.width;
    }
  } else if (viewRatio > 1) { // View is landscape
    if (imageRatio > 1) { // Image is landscape
      adjustedHeight = view.width / imageRatio;
      adjustedWidth = view.width;
      // If both are landscape, but image expands beyond height
      if (adjustedHeight > view.height) {
        adjustedHeight = view.height;
        adjustedWidth = view.height * imageRatio;
      }
    } else if (imageRatio < 1) { // Image is portrait
      adjustedHeight = view.height;
      adjustedWidth = view.height * imageRatio;
    } else { // Image is square
      adjustedHeight = view.height;
      adjustedWidth = view.height;
    }
  } else { // View is portrait
    if (imageRatio > 1) { // Image is landscape
      adjustedHeight = view.width / imageRatio;
      adjustedWidth = view.width;
    } else if (imageRatio < 1) { // Image is portrait
      adjustedHeight = view.height;
      adjustedWidth = view.height * imageRatio;
      // If both are portrait but image expands beyond width
      if (adjustedWidth > view.width) {
        adjustedHeight = view.width / imageRatio;
        adjustedWidth = view.width;
      }
    } else { // Image is square
      adjustedHeight = view.width;
      adjustedWidth = view.width;
    }
  }
  return {
    // src: logoSrc,
    width: adjustedWidth,
    height: adjustedHeight,
  };
}
